
import { Component, Vue, Prop } from 'vue-property-decorator'
import { commonModule, partnersModule } from '@/store/modules/store-accessor'

@Component
export default class DeletePartnerModal extends Vue {
  @Prop()
  payload!: any;

  isDeletingPartner = false;

async mounted() {
  commonModule.initSnackbar({});
}

  async hideModal () {
    commonModule.hideModal();
  }

  async hideSideView () {
    commonModule.hideSideview();
  }

  async doDeleteClient () {
        this.isDeletingPartner = true;
        await partnersModule.deletePartner(this.payload.partner);
        this.hideModal();
        this.hideSideView();
  }
};
